import { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';
import { api } from '../services/api';

export function useAuth() {
  const { user, isLoading, isAuthenticated, setUser, setLoading, logout } = useAuthStore();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await api.get('/auth/me');
        setUser(res.data.data);
      } catch {
        setUser(null);
      }
    };
    checkAuth();
  }, [setUser, setLoading]);

  const login = async (email: string, password: string) => {
    const res = await api.post('/auth/login', { email, password });
    setUser(res.data.data);
    return res.data.data;
  };

  const doLogout = async () => {
    await api.post('/auth/logout');
    logout();
  };

  return { user, isLoading, isAuthenticated, login, logout: doLogout };
}
